import { render, staticRenderFns } from "./TdClaimProductName.vue?vue&type=template&id=64a71b3a&"
import script from "./TdClaimProductName.vue?vue&type=script&lang=ts&"
export * from "./TdClaimProductName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports